<template>
  <div class="commercial-programming-view pa-4">
    <!-- Grilla y Filtros gestionados con s-crud -->
    <s-crud
      ref="programmingCrud"
      title="Programación Comercial"
      :config="config"
      :filter="filter"
      search-input
      singleRow
      add
      @add="openCreateModal"
      edit
      @edit="openEditModal"
      addNoFunction
      @rowSelected="onRowSelected($event)"
      @itemSelected="onItemSelected($event)"
      @doubleClick="openEditModal($event)"
      @dblClick="openEditModal($event)"
    >
      <!-- Slot de Filtros -->
      <template v-slot:filter>
        <v-container fluid class="pa-4">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="3">
              <s-select-campaign
                label="Campaña"
                v-model="filter.CmpID"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-select-definition
                v-model="filter.TypeDestination"
                :def="1175"
                label="División / Destino"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-select-definition
                v-model="filter.EcpStatus"
                :def="1746"
                label="Estado"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-date
                label="Fecha Desde"
                v-model="filter.DateBegin"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-date
                label="Fecha Hasta"
                v-model="filter.DateEnd"
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <!-- Slot de Opciones y Acciones de la Barra -->
      <template v-slot:options>
        <!-- Ver Detalle -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="openViewModal(selectedItemObject)"
              :disabled="!selectedItemObject || !selectedItemObject.EcpID"
            >
              <v-icon style="font-size:16px;">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>

        <!-- Resumen por Cliente -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="openCustomerSummaryModal(selectedItemObject)"
              :disabled="!selectedItemObject || !selectedItemObject.EcpID"
            >
              <v-icon style="font-size:16px;">mdi-account-group-outline</v-icon>
            </v-btn>
          </template>
          <span>Resumen por Cliente</span>
        </v-tooltip>

        <!-- Activar Programación (Cambio de Estado 1: Borrador -> 2: Activo) -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="activateProgramming(selectedItemObject)"
              :disabled="!selectedItemObject || !selectedItemObject.EcpID || selectedItemObject.EcpStatus !== 1"
            >
              <v-icon style="font-size:16px;">mdi-check-decagram-outline</v-icon>
            </v-btn>
          </template>
          <span>Activar Programación (Pasar a Activo)</span>
        </v-tooltip>

        <!-- Cerrar Programación (Cambio de Estado 2: Activo -> 3: Cerrado) -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="closeProgramming(selectedItemObject)"
              :disabled="!selectedItemObject || !selectedItemObject.EcpID || selectedItemObject.EcpStatus !== 2"
            >
              <v-icon style="font-size:16px;">mdi-lock-outline</v-icon>
            </v-btn>
          </template>
          <span>Cerrar Programación</span>
        </v-tooltip>

        <!-- Anular Programación -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="cancelProgramming(selectedItemObject)"
              :disabled="!selectedItemObject || !selectedItemObject.EcpID || selectedItemObject.EcpStatus === 4"
            >
              <v-icon style="font-size:16px;">mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>Anular Programación</span>
        </v-tooltip>

        <!-- Mantenimiento de Capacidades TM/FCL -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="showCapacityConfigModal = true"
            >
              <v-icon style="font-size:16px;">mdi-cog-box</v-icon>
            </v-btn>
          </template>
          <span>Mantenimiento de Capacidades TM/FCL</span>
        </v-tooltip>
      </template>

      <!-- Formateo de celdas personalizadas -->
      <template v-slot:[`item.EcpName`]="{ item }">
        <span class="font-weight-bold grey--text text--darken-4">{{ item.EcpName }}</span>
      </template>

      <template v-slot:[`item.EmbName`]="{ item }">
        <div>
          <span class="font-weight-medium grey--text text--darken-3">{{ item.EmbName }}</span>
          <v-chip x-small class="ml-1 font-weight-bold" color="grey lighten-4">v{{ item.EmbVersion }}</v-chip>
        </div>
      </template>

      <template v-slot:[`item.TypeDestinationName`]="{ item }">
        <v-chip
          x-small
          class="font-weight-bold"
          :color="item.TypeDestination === 1 ? 'green lighten-5' : 'blue lighten-5'"
          :text-color="item.TypeDestination === 1 ? 'green darken-4' : 'blue darken-4'"
        >
          {{ item.TypeDestinationName }}
        </v-chip>
      </template>

      <template v-slot:[`item.TotalProgrammedTons`]="{ item }">
        <span class="font-weight-bold">{{ item.TotalProgrammedTons | formatNumber }} TM</span>
      </template>

      <template v-slot:[`item.TotalProgrammedFcl`]="{ item }">
        <span>{{ item.TotalProgrammedFcl | formatNumber }}</span>
      </template>

      <template v-slot:[`item.TotalAmountContract`]="{ item }">
        <span class="font-weight-medium">${{ item.TotalAmountContract | formatNumber }}</span>
      </template>

      <template v-slot:[`item.TotalAmountFobEquivalent`]="{ item }">
        <span class="font-weight-bold font-mono">${{ item.TotalAmountFobEquivalent | formatNumber }}</span>
      </template>

      <template v-slot:[`item.BalanceTons`]="{ item }">
        <span :class="item.BalanceTons < 0 ? 'red--text font-weight-bold' : 'green--text text--darken-3 font-weight-medium'">
          {{ item.BalanceTons | formatNumber }} TM
        </span>
      </template>

      <template v-slot:[`item.StatusName`]="{ item }">
        <v-chip
          x-small
          class="font-weight-bold"
          :color="getStatusColor(item.EcpStatus)"
          :text-color="getStatusTextColor(item.EcpStatus)"
        >
          {{ item.StatusName }}
        </v-chip>
      </template>

      <template v-slot:[`item.EcpDate`]="{ item }">
        <span class="text-caption grey--text text--darken-2">{{ formatDate(item.EcpDate) }}</span>
      </template>
    </s-crud>

    <!-- Modal Formulario (Creación y Edición) -->
    <commercial-programming-form-modal
      v-if="modalForm.show"
      v-model="modalForm.show"
      :ecp-id="modalForm.ecpId"
      :is-view="modalForm.isView"
      @saved="onProgrammingSaved"
    />

    <!-- Modal Resumen por Cliente -->
    <commercial-programming-customer-summary-modal
      v-if="modalCustomerSummary.show"
      v-model="modalCustomerSummary.show"
      :ecp-id="modalCustomerSummary.ecpId"
      :ecp-name="modalCustomerSummary.ecpName"
    />

    <!-- Modal Mantenimiento de Capacidades -->
    <commercial-capacity-config-modal
      v-if="showCapacityConfigModal"
      v-model="showCapacityConfigModal"
      :default-division="filter.TypeDestination"
    />
  </div>
</template>

<script>
import _sCommercialProgramming from "@/services/ExternalTrade/CommercialProgrammingService";
import CommercialProgrammingFormModal from "./CommercialProgrammingFormModal.vue";
import CommercialProgrammingCustomerSummaryModal from "./CommercialProgrammingCustomerSummaryModal.vue";
import CommercialCapacityConfigModal from "./components/CommercialCapacityConfigModal.vue";

export default {
  name: "CommercialProgramming",
  components: {
    CommercialProgrammingFormModal,
    CommercialProgrammingCustomerSummaryModal,
    CommercialCapacityConfigModal,
  },
  filters: {
    formatNumber(val) {
      if (val === null || val === undefined || isNaN(val)) return "0.00";
      return new Intl.NumberFormat("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    },
  },
  data() {
    return {
      selectedProgramming: null,
      showCapacityConfigModal: false,
      filter: {
        CmpID: null,
        TypeDestination: null,
        EcpStatus: null,
        DateBegin: null,
        DateEnd: null,
      },
      config: {
        model: {
          EcpID: "ID",
          EcpDate: "date",
        },
        service: _sCommercialProgramming,
        headers: [
          { text: "#", value: "EcpID", width: "70px", align: "center" },
          { text: "Programación Comercial", value: "EcpName", align: "start" },
          { text: "Presupuesto Maestro", value: "EmbName", align: "start" },
          { text: "Campaña", value: "CmpName", align: "start", width: "120px" },
          { text: "División", value: "TypeDestinationName", align: "center", width: "110px" },
          { text: "TM Programadas", value: "TotalProgrammedTons", align: "end", width: "130px" },
          { text: "FCL Programados", value: "TotalProgrammedFcl", align: "end", width: "120px" },
          { text: "Importe Contractual USD", value: "TotalAmountContract", align: "end", width: "160px" },
          { text: "Importe FOB Eq USD", value: "TotalAmountFobEquivalent", align: "end", width: "150px" },
          { text: "Saldo TM vs Ppto", value: "BalanceTons", align: "end", width: "140px" },
          { text: "Estado", value: "StatusName", align: "center", width: "110px" },
          { text: "Fecha", value: "EcpDate", align: "center", width: "100px" },
        ],
      },
      modalForm: {
        show: false,
        ecpId: 0,
        isView: false,
      },
      modalCustomerSummary: {
        show: false,
        ecpId: 0,
        ecpName: "",
      },
    };
  },
  computed: {
    selectedItemObject() {
      if (!this.selectedProgramming) return null;
      if (Array.isArray(this.selectedProgramming)) {
        return this.selectedProgramming.length > 0 ? this.selectedProgramming[0] : null;
      }
      return this.selectedProgramming;
    },
  },
  methods: {
    onRowSelected(row) {
      if (Array.isArray(row)) {
        this.selectedProgramming = row.length > 0 ? row[0] : null;
      } else {
        this.selectedProgramming = row;
      }
    },

    onItemSelected(item) {
      this.selectedProgramming = item;
    },

    openCreateModal() {
      this.modalForm = {
        show: true,
        ecpId: 0,
        isView: false,
      };
    },

    openEditModal(item) {
      let prog = item;
      if (!prog || !prog.EcpID) {
        prog = this.selectedItemObject;
      }
      if (!prog || !prog.EcpID) {
        this.$fun.alert("Debe seleccionar una programación para editar.", "warning");
        return;
      }
      if (prog.EcpStatus === 3 || prog.EcpStatus === 4) {
        this.$fun.alert("No se puede editar una programación en estado Cerrado o Anulado.", "warning");
        return;
      }
      this.modalForm = {
        show: true,
        ecpId: prog.EcpID,
        isView: false,
      };
    },

    openViewModal(item) {
      const prog = item || this.selectedItemObject;
      if (!prog || !prog.EcpID) {
        this.$fun.alert("Debe seleccionar una programación para visualizar.", "warning");
        return;
      }
      this.modalForm = {
        show: true,
        ecpId: prog.EcpID,
        isView: true,
      };
    },

    openCustomerSummaryModal(item) {
      const prog = item || this.selectedItemObject;
      if (!prog || !prog.EcpID) {
        this.$fun.alert("Debe seleccionar una programación para ver el resumen por cliente.", "warning");
        return;
      }
      this.modalCustomerSummary = {
        show: true,
        ecpId: prog.EcpID,
        ecpName: prog.EcpName,
      };
    },

    async activateProgramming(item) {
      const prog = item || this.selectedItemObject;
      if (!prog || !prog.EcpID) return;

      this.$fun.alert(
        `¿Está seguro de activar la programación "${prog.EcpName}"? Pasará a estado Activo para operaciones comerciales.`,
        "question"
      ).then(async (r) => {
        if (r && r.value) {
          try {
            const res = await _sCommercialProgramming.activate(prog.EcpID, this.$fun.getUserID());
            if (res && res.data) {
              this.$fun.alert("La programación comercial ha sido activada correctamente.", "success");
              this.refreshGrid();
            }
          } catch (error) {
            const msg = (error.response && error.response.data) || error.message;
            this.$fun.alert(msg, "error");
          }
        }
      });
    },

    async closeProgramming(item) {
      const prog = item || this.selectedItemObject;
      if (!prog || !prog.EcpID) return;

      this.$fun.alert(
        `¿Está seguro de cerrar la programación "${prog.EcpName}"? No se permitirán modificaciones futuras.`,
        "question"
      ).then(async (r) => {
        if (r && r.value) {
          try {
            const res = await _sCommercialProgramming.close(prog.EcpID, this.$fun.getUserID());
            if (res && res.data) {
              this.$fun.alert("La programación comercial ha sido cerrada.", "success");
              this.refreshGrid();
            }
          } catch (error) {
            const msg = (error.response && error.response.data) || error.message;
            this.$fun.alert(msg, "error");
          }
        }
      });
    },

    async cancelProgramming(item) {
      const prog = item || this.selectedItemObject;
      if (!prog || !prog.EcpID) return;

      this.$fun.alert(
        `¿Está seguro de anular la programación "${prog.EcpName}"? Esta acción no se puede revertir.`,
        "question"
      ).then(async (r) => {
        if (r && r.value) {
          try {
            const res = await _sCommercialProgramming.cancel(prog.EcpID, this.$fun.getUserID());
            if (res && res.data) {
              this.$fun.alert("La programación comercial ha sido anulada.", "success");
              this.refreshGrid();
            }
          } catch (error) {
            const msg = (error.response && error.response.data) || error.message;
            this.$fun.alert(msg, "error");
          }
        }
      });
    },

    onProgrammingSaved() {
      this.refreshGrid();
    },

    refreshGrid() {
      if (this.$refs.programmingCrud && this.$refs.programmingCrud.refresh) {
        this.$refs.programmingCrud.refresh();
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 1:
          return "amber lighten-5";
        case 2:
          return "green lighten-5";
        case 3:
          return "blue-grey lighten-5";
        case 4:
          return "red lighten-5";
        default:
          return "grey lighten-4";
      }
    },

    getStatusTextColor(status) {
      switch (status) {
        case 1:
          return "amber darken-4";
        case 2:
          return "green darken-4";
        case 3:
          return "blue-grey darken-3";
        case 4:
          return "red darken-4";
        default:
          return "grey darken-3";
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "-";
      return date.toLocaleDateString("es-PE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.commercial-programming-view {
  width: 100%;
}
</style>
